module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAAXNSR0IArs4c6QAAAVBJREFUOBFjYMAC/v//7wfE+4H4AxSD2H5YlKIKARUxA3EnEOMCIDlmZF0syBwgux6Iy/7++/V/350Oxluvd4Gl1UTdGJxUKv4zM7GVAQV+AnEdWAJIMMIYQJPlgOwb/xn+cyw5G874+MNpmBSYlhUwZYgxXvmfkYHxB1BAg5GR8RFIggksCyFKgRTnpWerMTSDpEEGguRAaoAYpBYMkA1wAYlcer4WIoOFRJJzhkkje+ErUJCr/5ARw/ff72HyeOlqlweMyC7AqxiXJCMovnBJEiNOsQsoNgA9IcFd/e33O4bjD6YzAOObwUI+g4GLVQguh8zAacC26xUMt17vBqt99+0BQ4jeLGR9cDZOAz7+eAJUBIllCBuuB4WBMwzslYoZmBiZwRjExgVwukBFxJmBh10ErA/ExgVwGgDRAE+ouPQz4DVARcQJp0aYxMCnRABJIpGDu9TWIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/login.png
// module id = 1500
// module chunks = 1